module.exports = __webpack_public_path__ + "img/excavating_machinery-icon3.20c38042.png";